module.exports = __webpack_public_path__ + "static/media/Decorator.d7dd3666.jpg";